import { Injectable } from '@angular/core';
import { ValidatorFn, FormGroup } from '@angular/forms';
import {
    IDatiqInput,
    IDatiqInputValidatorService,
    IDatiqOption,
} from '@dat/datiq-components-pkg/utils';
import { DatiqInputValidatorsSelect } from '../validators';
import { IDatiqSelect } from '../models';

@Injectable({
    providedIn: 'root',
})
export class DatiqSelectValidatorsService
    implements IDatiqInputValidatorService
{
    constructor() {}

    addValidator(
        settings: IDatiqSelect,
        currentValidators: ValidatorFn[],
        formGroup?: FormGroup<any>
    ): ValidatorFn[] {
        return [
            ...currentValidators,
            DatiqInputValidatorsSelect.selectMatchesOptions(
                settings.options as IDatiqOption[]
            ),
        ];
    }
}
